import React from 'react';
import PropTypes from 'prop-types';
import t from '../i18n/I18n';

export default class ResendPassCode extends React.Component {
  static propType = {
    time: PropTypes.number, //In Minute Only
    resendPassCode: PropTypes.func
  };

  static defaultProps = {
    time: 1
  };

  state = {
    secondCount: 0,
    minuteCount: 0,
    showZeropadding: false,
    showButton: false
  };

  componentDidMount() {
    this.setInitalTime();
    let interval = setInterval(this.SecondCounter, 1000);
    this.setState({ interval: interval });
  }

  componentWillUnmount() {
    clearInterval(this.state.interval);
  }

  setInitalTime() {
    if (this.props.time > 0) {
      this.setState({
        secondCount: 59,
        minuteCount: this.props.time - 1
      });
    }
  }

  SecondCounter = () => {
    if (this.state.secondCount > 0) {
      this.setState({ secondCount: this.state.secondCount - 1 });
      if (this.state.secondCount < 10) {
        this.setState({ showZeropadding: true });
      }
    } else {
      this.minuteCounter();
    }

    if (this.state.secondCount <= 0 && this.state.minuteCount <= 0) {
      clearInterval(this.state.interval);
      this.setState({ showButton: true });
    }
  };

  minuteCounter = () => {
    if (this.state.minuteCount > 0) {
      this.setState({
        secondCount: 60,
        showZeropadding: false,
        minuteCount: this.state.minuteCount - 1
      });
    }
  };

  resendPassCode() {
    this.props.resendPassCode();
  }

  randerResendButton() {
    return (
      <div
        style={{ cursor: 'pointer', color: '#DF2714', textDecoration: 'underline' }}
        onClick={() => {
          this.resendPassCode();
        }}>
        {t('RESEND_INVITE_CODE')}
      </div>
    );
  }

  randerTimer() {
    return (
      <div>
        <span>{t('RESEND_INVITE_CODE')}&nbsp;</span>
        <span>
          {this.state.minuteCount}:{this.state.showZeropadding ? '0' : ''}
          {this.state.secondCount}
        </span>
      </div>
    );
  }

  render() {
    return (
      <div style={{ maxWidth: '180px' }}>{this.state.showButton ? this.randerResendButton() : this.randerTimer()}</div>
    );
  }
}
